import { render, staticRenderFns } from "./company.vue?vue&type=template&id=6235a3f0&scoped=true"
import script from "./company.vue?vue&type=script&lang=js"
export * from "./company.vue?vue&type=script&lang=js"
import style0 from "./company.vue?vue&type=style&index=0&id=6235a3f0&lang=css"
import style1 from "./company.vue?vue&type=style&index=1&id=6235a3f0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_d02125917f7c66a571cdcbfa3dd68341/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6235a3f0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/vue-hot-reload-api@2.3.4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6235a3f0')) {
      api.createRecord('6235a3f0', component.options)
    } else {
      api.reload('6235a3f0', component.options)
    }
    module.hot.accept("./company.vue?vue&type=template&id=6235a3f0&scoped=true", function () {
      api.rerender('6235a3f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/quarter/company.vue"
export default component.exports